module.exports = __webpack_public_path__ + "static/media/Fabrica.0b122449.otf";